import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { globalReducer } from './globalSettings/reducer';
import { resourcesReducer } from './resources';
import { selectedBubbleReducer } from './selectedBubble/reducer';

export const store = configureStore({
  reducer: {
    global: globalReducer,
    selectedBubble: selectedBubbleReducer,
    resources: resourcesReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
